<script>
import Modal from '../Modal.vue'
import axios from 'axios';

export default {
    components: {
        Modal
    },

    props: {
        id: {
            type: String,
            default: true
        },
        staticBackdrop: {
            type: Boolean,
            default: false
        },
        timesButton: {
            type: Boolean,
            default: true
        },
        csrfToken: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            reason: '',
            errors: []
        }
    },

    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggle()
        },
    }
}
</script>

<template>
    <div>
        <a @click="toggleModal(`modalReject${id}`)">Reject</a>
        <modal
            :ref="`modalReject${id}`"
            heading="Rejection of Reactivate Account"
            :times-button="timesButton"
            :static-backdrop="staticBackdrop">
            <div>
                <form method="POST">
                    <input type="hidden" name="_csrfToken" :value="csrfToken" />
                    <input type="hidden" name="id" :value="id" />
                    <input type="hidden" name="reason" :value="reason" />
                    <div class="small-12 text-left">
                        <div>Select a reason.</div>
                        <div>
                            <select v-model="reason" class="form-control">
                                <option value="">Select a reason</option>
                                <option value="Personal info does not match (Details provided do not align with records).">Personal info does not match (Details provided do not align with records).</option>
                                <option value="Incorrect or missing ID uploaded (Other documents uploaded instead of an official ID).">Incorrect or missing ID uploaded (Other documents uploaded instead of an official ID).</option>
                            </select>
                        </div>
                        <div><input :disabled="reason===''" type="submit" class="button mt-3" value="Submit"></div>
                        <div v-if="errors.length > 0">
                            <div class="text-danger" v-for="error in errors" :key="error">
                                <small> {{ error }}</small>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

